import { Reveal, SectionLabel } from "./Reveal";
import { BRAND_CATEGORIES } from "../data/brands";

function BrandTile({ brand }) {
  return (
    <div
      data-testid={`brand-tile-${brand.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className="group grid place-items-center h-20 rounded-xl border border-border bg-white px-3 transition-all duration-300 hover:border-accent hover:shadow-[0_8px_24px_rgba(0,0,0,0.12)]"
      title={brand.name}
    >
      {brand.logo ? (
        <img
          src={brand.logo}
          alt={`${brand.name} logo`}
          loading="lazy"
          className="max-h-11 max-w-[85%] object-contain transition-transform duration-300 group-hover:scale-105"
        />
      ) : (
        <span className="text-center font-serif-display text-lg leading-tight text-neutral-500 transition-colors duration-300 group-hover:text-[hsl(147_40%_24%)]">
          {brand.name}
        </span>
      )}
    </div>
  );
}

export default function BrandsSection() {
  return (
    <section className="border-y border-border bg-secondary/30" data-testid="brands-section">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <Reveal><SectionLabel>Brands & Materials</SectionLabel></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif-display text-4xl md:text-5xl mt-5 max-w-3xl leading-tight">
            We build with brands you already trust
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-6 max-w-2xl text-muted-foreground leading-relaxed">
            Every Kalpavriksha project is finished with premium, warranty-backed materials from
            India's most respected manufacturers — no compromises, no unbranded substitutes.
          </p>
        </Reveal>

        <div className="mt-14 space-y-12">
          {BRAND_CATEGORIES.map((cat, i) => (
            <Reveal key={cat.category} delay={i * 0.05}>
              <div className="grid gap-5 md:grid-cols-[180px_1fr] md:items-start">
                <div className="flex items-center gap-3 md:pt-6">
                  <span className="h-px w-8 bg-accent" />
                  <h3 className="label-caps text-accent">{cat.category}</h3>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                  {cat.brands.map((b, j) => (
                    <BrandTile key={`${cat.category}-${b.name}-${j}`} brand={b} />
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
